// Surveys (polls): shared helpers for the pop-up, the home page banner and the welcome pop-up.
// The survey itself (question, options, dates) comes from the server (see hooks/useCurrentPoll.js).

// Master switch. While false the poll pop-up, the home page banner and every request to the poll server
// are off, so the site can go live without the poll database tables and PHP files.
export const POLL_ENABLED = false;

const votedKey = (pollKey) => `poll_voted_ids_${pollKey}`;

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // storage blocked: the poll just shows again next visit
  }
};

export const POLL_OPEN_EVENT = "poll-open";
export const POLL_VOTED_EVENT = "poll-voted";

// Which customer accounts have voted in this survey on this browser (so another account on the same device can still vote)
const getVotedIds = (pollKey) => {
  try {
    const ids = JSON.parse(safeGet(votedKey(pollKey)) || "[]");
    return Array.isArray(ids) ? ids.map(Number) : [];
  } catch {
    return [];
  }
};

// Remember that this customer has voted (the server is the real record)
export const markPollVoted = (pollKey, customerId) => {
  const id = Number(customerId);
  if (pollKey && id) {
    const ids = getVotedIds(pollKey);
    if (!ids.includes(id)) safeSet(votedKey(pollKey), JSON.stringify([...ids, id]));
  }
  window.dispatchEvent(new Event(POLL_VOTED_EVENT));
};

// Has this customer account voted in this survey? Logged-out visitors count as not voted: they have to log in to vote anyway.
export const hasVotedHere = (pollKey, customerId) =>
  Boolean(pollKey) && Boolean(customerId) && getVotedIds(pollKey).includes(Number(customerId));

// Lets the link on the home page open the poll pop-up
export const openPoll = () => window.dispatchEvent(new Event(POLL_OPEN_EVENT));

// Is this survey worth showing for this customer right now? (The server has the final say on votes.)
export const isPollActiveHere = (poll, customerId) => {
  if (!POLL_ENABLED || !poll) return false;

  // Testing aid, local development only: open any page with ?resetpoll=1 to forget earlier votes on this browser
  if (process.env.NODE_ENV !== "production" && new URLSearchParams(window.location.search).get("resetpoll") === "1") {
    try {
      localStorage.removeItem(votedKey(poll.key));
    } catch {
      // storage blocked
    }
  }

  return !hasVotedHere(poll.key, customerId);
};
